module.exports = __webpack_public_path__ + "img/xtz.6b052c0e.svg";